export enum ReactionResultStatusEnum {
    ALL = -1,
    SUBMITTED = 0,
    RECEIVED,
    IN_PROGRESS,
    COMPLETED,
    ACTION_REQUIRED,
    CANCELED,
    CANCELED_FROM_LIMS,
}
